module.exports = __webpack_public_path__ + "media/gateway/credix-checkout-grande-554d65f4.png";